<template>
  <span>{{ output }}</span>
</template>

<script>
import numeral from "numeral";
import "numeral/locales/de";

export default {
  props: {
    number: {
      type: Number,
      required: true,
    },

    format: {
      type: String,
      default: null,
    },
  },

  computed: {
    output() {
      numeral.locale(this.$i18n.locale);
      return numeral(this.number).format(this.format);
    },
  },
};
</script>
